(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var revealEls = document.querySelectorAll('.rc-aboutban .rc-reveal');
    if (!('IntersectionObserver' in window) || revealEls.length === 0) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-features"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var revealEls = document.querySelectorAll('.rc-aboutfeat .rc-reveal');
    if (!('IntersectionObserver' in window) || revealEls.length === 0) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-articles"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var revealEls = document.querySelectorAll('.rc-articles .rc-reveal');
    if (!('IntersectionObserver' in window) || revealEls.length === 0) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-story"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var revealEls = document.querySelectorAll('.rc-story .rc-reveal');
    if (!('IntersectionObserver' in window) || revealEls.length === 0) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var revealEls = document.querySelectorAll('.rc-categories .rc-reveal');
    if (!('IntersectionObserver' in window) || revealEls.length === 0) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  });

  /* RoyalCare: "Alege după nevoia ta" - pick a need, show its panel */
  if (!customElements.get('rc-need-finder')) {
    customElements.define('rc-need-finder', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-rc-need]'));
        this.panels = Array.prototype.slice.call(this.querySelectorAll('.rc-needs__panel'));
        this.panelsBox = this.querySelector('.rc-needs__panels');
        this.mq = window.matchMedia('(max-width: 749px)');
        var self = this;
        this.place();
        this.mq.addEventListener('change', function () { self.place(); });
        this.tabs.forEach(function (tab, i) {
          tab.addEventListener('click', function () {
            if (self.mq.matches && tab.classList.contains('is-active')) self.select(-1);
            else self.select(i, true);
          });
          tab.addEventListener('keydown', function (e) {
            if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            e.preventDefault();
            var n = (i + (e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : -1) + self.tabs.length) % self.tabs.length;
            self.select(n, true);
            self.tabs[n].focus();
          });
        });
      }

      /* Mobile: each panel sits right under its need (accordion, all closed at first). Desktop: panels on the right. */
      place() {
        var self = this;
        if (this.mq.matches) {
          this.tabs.forEach(function (tab, i) { tab.after(self.panels[i]); });
          this.select(0);
        } else {
          this.panels.forEach(function (p) { self.panelsBox.appendChild(p); });
          var active = this.tabs.findIndex(function (t) { return t.classList.contains('is-active'); });
          this.select(active < 0 ? 0 : active);
        }
      }

      select(index, scroll) {
        this.tabs.forEach(function (t, i) {
          t.classList.toggle('is-active', i === index);
          t.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
        this.panels.forEach(function (p, i) {
          p.hidden = i !== index;
          p.classList.toggle('is-active', i === index);
        });
        var tab = this.tabs[index];
        if (scroll && tab && this.mq.matches) {
          var top = tab.getBoundingClientRect().top;
          if (top < 70) window.scrollBy({ top: top - 90, behavior: 'smooth' });
        }
      }
    });
  }

  /* RoyalCare: "Alege după nevoia ta" (consult layout) - pick a need, show its panel */
  if (!customElements.get('rc-need-consult')) {
    customElements.define('rc-need-consult', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-rc-consult]'));
        this.panels = Array.prototype.slice.call(this.querySelectorAll('.rc-consult__panel'));
        this.tabs.forEach(function (tab, i) {
          tab.addEventListener('click', function () { self.select(i); });
          tab.addEventListener('keydown', function (e) {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            e.preventDefault();
            var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + self.tabs.length) % self.tabs.length;
            self.select(n);
            self.tabs[n].focus();
          });
        });
      }

      select(index) {
        this.tabs.forEach(function (t, i) {
          t.classList.toggle('is-active', i === index);
          t.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
        this.panels.forEach(function (p, i) {
          p.hidden = i !== index;
          p.classList.toggle('is-active', i === index);
        });
        var tab = this.tabs[index];
        if (tab && tab.scrollIntoView && window.matchMedia('(max-width: 749px)').matches) {
          tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }
      }
    });
  }

  /* RoyalCare: "Alege după nevoia ta" (quiz layout) - 1) area, 2) concern of that area, 3) recommendation */
  if (!customElements.get('rc-need-quiz')) {
    customElements.define('rc-need-quiz', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.steps = {
          1: this.querySelector('[data-rc-quiz-step="1"]'),
          2: this.querySelector('[data-rc-quiz-step="2"]'),
          3: this.querySelector('[data-rc-quiz-step="3"]')
        };
        this.querySelectorAll('[data-rc-quiz-area]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var id = btn.getAttribute('data-rc-quiz-area');
            self.area = id;
            if (btn.getAttribute('data-rc-quiz-needs') === 'true') self.showGroup(id);
            else self.showAnswer('a-' + id);
          });
        });
        this.querySelectorAll('[data-rc-quiz-pick]').forEach(function (btn) {
          btn.addEventListener('click', function () { self.showAnswer(btn.getAttribute('data-rc-quiz-pick')); });
        });
        /* perfumes: who + note in step 2 (0 = any); notes with no perfume for the chosen "who" are disabled */
        this.querySelectorAll('[data-rc-pf]').forEach(function (box) {
          var areaId = box.getAttribute('data-rc-pf');
          function val(row) {
            var on = box.querySelector('[data-rc-pf-row="' + row + '"] .is-on');
            return on ? on.getAttribute('data-rc-pf-val') : '0';
          }
          function keyFor(w, n) { return (w === '0' && n === '0') ? 'a-' + areaId : 'pf-' + areaId + '-' + w + '-' + n; }
          function hasAnswer(k) { return !!self.querySelector('[data-rc-quiz-answer="' + k + '"]'); }
          function refresh() {
            var w = val('who');
            box.querySelectorAll('[data-rc-pf-row="note"] [data-rc-pf-val]').forEach(function (chip) {
              var ok = hasAnswer(keyFor(w, chip.getAttribute('data-rc-pf-val')));
              chip.disabled = !ok;
              if (!ok && chip.classList.contains('is-on')) {
                chip.classList.remove('is-on');
                box.querySelector('[data-rc-pf-row="note"] [data-rc-pf-val="0"]').classList.add('is-on');
              }
            });
          }
          box.querySelectorAll('[data-rc-pf-val]').forEach(function (chip) {
            chip.addEventListener('click', function () {
              chip.parentElement.querySelectorAll('.is-on').forEach(function (c) { c.classList.remove('is-on'); });
              chip.classList.add('is-on');
              refresh();
            });
          });
          box.querySelector('[data-rc-pf-go]').addEventListener('click', function () {
            self.showAnswer(keyFor(val('who'), val('note')));
          });
          refresh();
        });
        this.querySelectorAll('[data-rc-quiz-more]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var box = btn.closest('.rc-quiz__options');
            if (box) box.classList.add('is-expanded');
          });
        });
        this.querySelectorAll('[data-rc-quiz-back]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (btn.getAttribute('data-rc-quiz-back') === '2' && self.area) self.showGroup(self.area);
            else self.go(1);
          });
        });
      }

      go(step) {
        var self = this;
        [1, 2, 3].forEach(function (n) {
          if (self.steps[n]) self.steps[n].hidden = n !== step;
          var dot = self.querySelector('[data-rc-quiz-dot="' + n + '"]');
          if (dot) dot.classList.toggle('is-on', n <= step);
        });
        [1, 2].forEach(function (n) {
          var bar = self.querySelector('[data-rc-quiz-bar="' + n + '"]');
          if (bar) bar.classList.toggle('is-on', n < step);
        });
        this.bringIntoView();
      }

      showGroup(id) {
        this.querySelectorAll('[data-rc-quiz-group]').forEach(function (g) {
          g.hidden = g.getAttribute('data-rc-quiz-group') !== id;
        });
        this.go(2);
      }

      showAnswer(key) {
        var found = false;
        this.querySelectorAll('[data-rc-quiz-answer]').forEach(function (a) {
          var match = a.getAttribute('data-rc-quiz-answer') === key;
          a.hidden = !match;
          if (match) found = true;
        });
        if (found) this.go(3);
      }

      bringIntoView() {
        var top = this.getBoundingClientRect().top;
        if (top < 60 || top > window.innerHeight * 0.5) {
          this.style.scrollMarginTop = '90px';
          this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-catalog-c"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('change', function (event) {
      var select = event.target;
      if (!select.matches || !select.matches('[data-rc-sort-c]')) return;
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', select.value);
      params.delete('page');
      window.location.search = params.toString();
    });

    document.addEventListener('click', function (event) {
      var open = event.target.closest && event.target.closest('[data-rc-colc-open]');
      var close = event.target.closest && event.target.closest('[data-rc-colc-close]');
      if (!open && !close) return;
      var root = (open || close).closest('[data-rc-colc]');
      var side = root && root.querySelector('.rc-colc__side');
      if (!side) return;
      var isOpen = !!open;
      side.classList.toggle('is-open', isOpen);
      document.documentElement.style.overflow = isOpen ? 'hidden' : '';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-filters-b"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select.matches || !select.matches('[data-rc-sort-b]')) return;
    var params = new URLSearchParams(window.location.search);
    params.set('sort_by', select.value);
    params.delete('page');
    window.location.search = params.toString();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var revealEls = document.querySelectorAll('.rc-colhead .rc-reveal');
    if (!('IntersectionObserver' in window) || revealEls.length === 0) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-product-grid"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var revealEls = document.querySelectorAll('.rc-colgrid .rc-reveal');
    if (!('IntersectionObserver' in window) || revealEls.length === 0) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-toolbar"] && !Shopify.designMode) return;
  try {
    
  /* RoyalCare: collection description clamped to 2 lines; "Vezi mai mult" only when it is longer */
  (function () {
    function initDesc(desc) {
      if (desc.dataset.rcMore) return;
      desc.dataset.rcMore = '1';
      if (desc.scrollHeight <= desc.clientHeight + 2) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rc-desc-more';
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = '<span>Vezi mai mult</span><i class="fa-solid fa-chevron-down" aria-hidden="true"></i>';
      btn.addEventListener('click', function () {
        var open = desc.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.querySelector('span').textContent = open ? 'Vezi mai puțin' : 'Vezi mai mult';
      });
      desc.insertAdjacentElement('afterend', btn);
    }
    function initAllDesc() { document.querySelectorAll('.rc-coltools__pagehead-desc, .rc-offerhead__desc').forEach(initDesc); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllDesc);
    else initAllDesc();
    document.addEventListener('shopify:section:load', initAllDesc);
  })();
  /* RoyalCare: mobile finder switch - one segment per finder row (label + icon), only the chosen row is shown */
  (function () {
    function initSwitch(finder) {
      var seg = finder.querySelector('.rc-finder__seg');
      if (!seg || seg.childElementCount) return;
      var rows = Array.prototype.slice.call(finder.querySelectorAll(':scope > .rc-finder__row'));
      if (rows.length < 2) return;
      var start = 0;
      rows.forEach(function (row, i) {
        if (row.querySelector('.rc-coltools__card--active, .rc-coltools__type--active') && !start) start = i;
        var label = row.querySelector('.rc-finder__text strong');
        var icon = row.querySelector('.rc-finder__icon i');
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('role', 'tab');
        b.innerHTML = (icon ? icon.outerHTML : '') + '<span>' + (label ? label.textContent.trim() : '') + '</span>';
        b.addEventListener('click', function () { show(i); });
        seg.appendChild(b);
      });
      function show(n) {
        rows.forEach(function (row, i) { row.classList.toggle('is-shown', i === n); });
        Array.prototype.forEach.call(seg.children, function (b, i) {
          b.classList.toggle('is-on', i === n);
          b.setAttribute('aria-selected', i === n ? 'true' : 'false');
        });
      }
      /* 3 tiles + "Vezi mai multe" when a row has more than 4 (an active choice stays visible) */
      rows.forEach(function (row) {
        var track = row.querySelector('.rc-coltools__cards, .rc-coltools__types');
        if (!track || track.querySelector('.rc-finder__more')) return;
        var items = Array.prototype.slice.call(track.children);
        if (items.length <= 4) return;
        var activeIndex = items.findIndex(function (el) { return /--active/.test(el.className); });
        if (activeIndex > 2) return;
        var extra = items.slice(3);
        extra.forEach(function (el) { el.classList.add('rc-finder-extra'); });
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'rc-finder__more';
        more.innerHTML = '<span class="rc-finder__more-media"><i class="fa-solid fa-plus" aria-hidden="true"></i></span>' +
          '<span class="rc-finder__more-text"><strong>Vezi mai multe</strong><small>încă ' + extra.length + ' opțiuni</small></span>';
        more.addEventListener('click', function () {
          extra.forEach(function (el) { el.classList.remove('rc-finder-extra'); });
          more.remove();
        });
        track.insertBefore(more, extra[0]);
      });
      show(start);
      finder.classList.add('is-ready');
    }
    function initAll() { document.querySelectorAll('.rc-finder--switch').forEach(initSwitch); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.rc-coltools').forEach(function (toolbar) {
      var drawer = document.querySelector('[data-rc-filter-drawer]');
      var openBtn = toolbar.querySelector('[data-rc-filter-open]');
      if (!drawer || !openBtn) return;

      function openDrawer() {
        drawer.hidden = false;
        requestAnimationFrame(function () {
          drawer.classList.add('rc-is-open');
        });
        document.documentElement.style.overflow = 'hidden';
      }

      function closeDrawer() {
        drawer.classList.remove('rc-is-open');
        document.documentElement.style.overflow = '';
        setTimeout(function () {
          drawer.hidden = true;
        }, 350);
      }

      openBtn.addEventListener('click', openDrawer);

      /* live "Vezi N produse": ask the collection page how many products match the current choice */
      var form = drawer.querySelector('[data-rc-filter-form]');
      var applyBtn = drawer.querySelector('[data-rc-apply]');
      var timer = null;
      var reqId = 0;
      function query() {
        var params = new URLSearchParams();
        new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '') params.append(k, v); });
        return params;
      }
      function refreshCount() {
        var id = ++reqId;
        if (applyBtn) applyBtn.classList.add('is-loading');
        fetch(form.getAttribute('action') + '?' + query().toString(), { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            if (id !== reqId) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var n = doc.querySelector('.rc-coltools__count strong');
            if (n) drawer.querySelectorAll('[data-rc-live-count]').forEach(function (el) { el.textContent = n.textContent.trim(); });
          })
          .catch(function () {})
          .finally(function () { if (id === reqId && applyBtn) applyBtn.classList.remove('is-loading'); });
      }
      if (form) {
        form.addEventListener('change', function () { clearTimeout(timer); timer = setTimeout(refreshCount, 250); });
        form.addEventListener('input', function (e) {
          if (e.target.type === 'number') { clearTimeout(timer); timer = setTimeout(refreshCount, 600); }
        });
        /* price inputs are shown in lei, Shopify expects the same unit in the URL */
      }
      drawer.querySelectorAll('[data-rc-filter-close]').forEach(function (btn) {
        btn.addEventListener('click', closeDrawer);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('rc-is-open')) {
          closeDrawer();
        }
      });
    });

    /* sort select in the bar: apply right away */
    document.querySelectorAll('[data-rc-sort-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });

    document.querySelectorAll('.rc-coltools').forEach(function (tb) {
      [['cards', '.rc-coltools__card'], ['types', '.rc-coltools__type']].forEach(function (pair) {
        tb.querySelectorAll('.rc-coltools__' + pair[0]).forEach(function (track) {
        var row = track.closest('.rc-finder__row') || tb;
        var prev = row.querySelector('[data-rc-' + pair[0] + '-prev]');
        var next = row.querySelector('[data-rc-' + pair[0] + '-next]');
        if (!prev || !next) return;
        function step() {
          var c = track.querySelector(pair[1]);
          return c ? c.getBoundingClientRect().width + 10 : 190;
        }
        function update() {
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        }
        prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); setTimeout(update, 450); });
        next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); setTimeout(update, 450); });
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var revealEls = document.querySelectorAll('.rc-contact .rc-reveal');
    if (!('IntersectionObserver' in window) || revealEls.length === 0) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var revealEls = document.querySelectorAll('.rc-faq .rc-reveal');
    if (!('IntersectionObserver' in window) || revealEls.length === 0) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-custom"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var revealEls = document.querySelectorAll('.rc-footer .rc-reveal');
    if (!('IntersectionObserver' in window) || revealEls.length === 0) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-split"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var revealEls = document.querySelectorAll('.rc-hero .rc-reveal');
    revealEls.forEach(function (el, i) {
      if (!('IntersectionObserver' in window)) {
        el.classList.add('is-in');
        return;
      }
      setTimeout(function () { el.classList.add('is-in'); }, i * 120);
    });
  });

  /* RoyalCare hero: real average rating from Judge.me */
  (function () {
    function load() {
      document.querySelectorAll('[data-rc-hero-rating]').forEach(function (el) {
        if (el.__rcDone) return;
        el.__rcDone = true;
        var url = 'https://judge.me/api/v1/widgets/all_reviews_page?shop_domain=' + encodeURIComponent(el.getAttribute('data-shop'))
          + '&api_token=0Ug1M_aYNEnpvIKuNs3YzWV3zIA&per_page=1&page=1&_=' + Math.floor(Date.now() / 600000);
        fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
          if (!d || !d.all_reviews_header) return;
          var h = new DOMParser().parseFromString(d.all_reviews_header, 'text/html').querySelector('.jdgm-all-reviews__header');
          if (!h) return;
          var avg = parseFloat(h.getAttribute('data-average-rating')) || 0;
          var n = parseInt(h.getAttribute('data-number-of-reviews'), 10) || 0;
          if (!n || avg < 4) return;
          el.querySelector('[data-rc-hero-avg]').textContent = avg.toFixed(1).replace('.', ',');
          el.querySelector('[data-rc-hero-count]').textContent = n + (n === 1 ? ' recenzie' : ' recenzii');
          if (!document.getElementById('recenzii-home')) {
            var target = document.querySelector('.rc-hrev');
            if (target) target.id = 'recenzii-home'; else el.removeAttribute('href');
          }
          el.hidden = false;
        }).catch(function () {});
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load); else load();
    document.addEventListener('shopify:section:load', load);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      var track = section.querySelector('.rc-hcolls__grid');
      var prev = section.querySelector('[data-rc-hcolls-prev]');
      var next = section.querySelector('[data-rc-hcolls-next]');
      if (!track || !prev || !next || track.dataset.rcReady) return;
      track.dataset.rcReady = '1';

      // Random order on every page view (the tiles are rendered in the editor's order, then shuffled here)
      if (track.hasAttribute('data-rc-shuffle')) {
        var items = Array.prototype.slice.call(track.children);
        for (var i = items.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var t = items[i]; items[i] = items[j]; items[j] = t;
        }
        items.forEach(function (el) { track.appendChild(el); });
      }

      function step() {
        var item = track.querySelector('.rc-hcolls__item');
        if (!item) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      }

      function go(direction) {
        track.scrollBy({ left: direction * step(), behavior: 'smooth' });
        setTimeout(update, 450);
      }

      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    function initAll() {
      document.querySelectorAll('.rc-hcolls').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-reviews"] && !Shopify.designMode) return;
  try {
    
  /* RoyalCare: homepage reviews from Judge.me (random order on every visit) */
  (function () {
    var TOKEN = '0Ug1M_aYNEnpvIKuNs3YzWV3zIA';

    function esc(s) {
      return String(s || '').replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function stars(n) {
      var html = '';
      for (var i = 1; i <= 5; i++) {
        var cls = n >= i ? 'fa-solid fa-star' : n >= i - 0.5 ? 'fa-solid fa-star-half-stroke' : 'fa-regular fa-star';
        html += '<i class="' + cls + '"></i>';
      }
      return html;
    }

    function shuffle(list) {
      for (var i = list.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = list[i]; list[i] = list[j]; list[j] = t;
      }
      return list;
    }

    function parse(el) {
      var bodyEl = el.querySelector('.jdgm-rev__body');
      var body = bodyEl ? (Array.prototype.map.call(bodyEl.querySelectorAll('p'), function (p) { return p.textContent.trim(); }).filter(Boolean).join(' ') || bodyEl.textContent.trim()) : '';
      var link = el.querySelector('.jdgm-rev__prod-link');
      var handle = '';
      if (link) {
        var m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        if (m) handle = decodeURIComponent(m[1]);
      }
      var ratingEl = el.querySelector('.jdgm-rev__rating');
      return {
        rating: parseInt(ratingEl && ratingEl.getAttribute('data-score'), 10) || 5,
        author: ((el.querySelector('.jdgm-rev__author') || {}).textContent || 'Client').trim() || 'Client',
        title: ((el.querySelector('.jdgm-rev__title') || {}).textContent || '').trim(),
        body: body,
        verified: el.getAttribute('data-verified-buyer') === 'true',
        handle: handle,
        productTitle: link ? link.textContent.trim() : ''
      };
    }

    function card(r, products) {
      var p = products[r.handle] || null;
      var text = r.body || r.title;
      var html = '<article class="rc-hrev__card">';
      html += '<div class="rc-hrev__top"><span class="rc-hrev__stars" aria-label="' + r.rating + ' din 5 stele">' + stars(r.rating) + '</span></div>';
      if (r.title && r.body) html += '<p class="rc-hrev__text"><strong>' + esc(r.title) + (/[.!?…]\s*$/.test(r.title.replace(/[\u00a0\u200b]/g, ' ').trim()) ? '' : '.') + '</strong> ' + esc(r.body) + '</p>';
      else html += '<p class="rc-hrev__text">' + esc(text) + '</p>';
      html += '<div class="rc-hrev__author"><span class="rc-hrev__avatar">' + esc(r.author.charAt(0).toUpperCase()) + '</span>'
        + '<span class="rc-hrev__who"><strong>' + esc(r.author) + '</strong>'
        + (r.verified ? '<span><i class="fa-solid fa-circle-check"></i> Client verificat</span>' : '')
        + '</span></div>';
      if (p || r.productTitle) {
        var url = p ? p.u : '/products/' + encodeURIComponent(r.handle);
        html += '<a class="rc-hrev__product" href="' + esc(url) + '">'
          + (p && p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy" width="44" height="44">' : '')
          + '<span class="rc-hrev__product-info"><small>Recenzie pentru</small><span>' + esc(p ? p.t : r.productTitle) + '</span></span>'
          + '<i class="fa-solid fa-arrow-right" aria-hidden="true"></i></a>';
      }
      return html + '</article>';
    }

    function init(section) {
      if (section.__rcInit) return;
      section.__rcInit = true;
      var shop = section.getAttribute('data-shop');
      var max = parseInt(section.getAttribute('data-max'), 10) || 12;
      var minRating = parseInt(section.getAttribute('data-min-rating'), 10) || 4;
      var products = {};
      try { products = JSON.parse(section.querySelector('[data-rc-hrev-products]').textContent); } catch (e) {}
      var track = section.querySelector('[data-rc-hrev-track]');
      var prev = section.querySelector('[data-rc-hrev-prev]');
      var next = section.querySelector('[data-rc-hrev-next]');

      var url = 'https://judge.me/api/v1/widgets/all_reviews_page?shop_domain=' + encodeURIComponent(shop)
        + '&api_token=' + TOKEN + '&per_page=100&page=1&_=' + Math.floor(Date.now() / 600000);
      fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (data) {
        if (!data || !data.all_reviews) throw new Error('no data');
        var doc = new DOMParser().parseFromString((data.all_reviews_header || '') + data.all_reviews, 'text/html');
        var reviews = Array.prototype.map.call(doc.querySelectorAll('.jdgm-rev'), parse).filter(function (r) {
          return r.rating >= minRating && (r.body || r.title) && r.handle;
        });
        if (!reviews.length) throw new Error('empty');
        /* review photos and dates are not shown (owner's choice): a random selection of text reviews */
        var picked = shuffle(reviews).slice(0, max);
        track.innerHTML = picked.map(function (r) { return card(r, products); }).join('');

        var header = doc.querySelector('.jdgm-all-reviews__header');
        var summary = section.querySelector('[data-rc-hrev-summary]');
        if (header && summary) {
          var avg = parseFloat(header.getAttribute('data-average-rating')) || 0;
          var count = parseInt(header.getAttribute('data-number-of-reviews'), 10) || reviews.length;
          section.querySelector('[data-rc-hrev-avg]').textContent = avg.toFixed(1).replace('.', ',');
          section.querySelector('[data-rc-hrev-avg-stars]').innerHTML = stars(avg);
          section.querySelector('[data-rc-hrev-count]').textContent = count + (count === 1 ? ' recenzie' : ' recenzii');
          var bars = '';
          for (var s = 5; s >= 1; s--) {
            var row = doc.querySelector('.jdgm-histogram__row[data-rating="' + s + '"]');
            var pct = row ? parseInt(row.getAttribute('data-percentage'), 10) || 0 : 0;
            var freq = row ? parseInt(row.getAttribute('data-frequency'), 10) || 0 : 0;
            bars += '<li><span>' + s + '<i class="fa-solid fa-star"></i></span><span class="rc-hrev__bar"><span style="width:' + pct + '%"></span></span><em>' + freq + '</em></li>';
          }
          section.querySelector('[data-rc-hrev-bars]').innerHTML = bars;
          summary.hidden = false;
        }

        function step() {
          var c = track.querySelector('.rc-hrev__card');
          return c ? c.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : track.clientWidth;
        }
        function update() {
          var maxScroll = track.scrollWidth - track.clientWidth - 2;
          prev.hidden = next.hidden = maxScroll <= 0;
          prev.disabled = track.scrollLeft <= 0;
          next.disabled = track.scrollLeft >= maxScroll;
        }
        prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
        next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      }).catch(function () {
        section.setAttribute('data-rc-hrev-empty', '');
      });
    }

    function boot() {
      document.querySelectorAll('.rc-hrev').forEach(function (section) {
        if (!('IntersectionObserver' in window)) return init(section);
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { io.disconnect(); init(section); }
          });
        }, { rootMargin: '600px 0px' });
        io.observe(section);
        /* safety net: load anyway shortly after the page (some browsers report the intersection late) */
        setTimeout(function () { io.disconnect(); init(section); }, 3500);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal-content"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var revealEls = document.querySelectorAll('.rc-legal .rc-reveal');
    if (!('IntersectionObserver' in window) || revealEls.length === 0) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-strip"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var revealEls = document.querySelectorAll('.rc-nlstrip .rc-reveal');
    if (!('IntersectionObserver' in window) || revealEls.length === 0) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["payment-methods"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var revealEls = document.querySelectorAll('.rc-paymethods .rc-reveal');
    if (!('IntersectionObserver' in window) || revealEls.length === 0) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["process-steps"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var revealEls = document.querySelectorAll('.rc-process .rc-reveal');
    if (!('IntersectionObserver' in window) || revealEls.length === 0) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-banner"] && !Shopify.designMode) return;
  try {
    
  /* RoyalCare: match the banner's text side to the colour at the photo's left edge. */
  (function () {
    function sample(banner) {
      var img = banner.querySelector('.rc-pbanner__media img');
      var inner = banner.querySelector('.rc-pbanner__inner');
      if (!img || !inner) return;
      function apply() {
        try {
          var canvas = document.createElement('canvas');
          canvas.width = 48;
          canvas.height = 48;
          var ctx = canvas.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(img, 0, 0, 48, 48);
          var data = ctx.getImageData(0, 4, 4, 40).data; /* left edge, a few pixels wide */
          var r = 0, g = 0, b = 0, n = data.length / 4;
          for (var i = 0; i < data.length; i += 4) {
            r += data[i];
            g += data[i + 1];
            b += data[i + 2];
          }
          inner.style.setProperty('--rc-pbanner-bg', 'rgb(' + Math.round(r / n) + ',' + Math.round(g / n) + ',' + Math.round(b / n) + ')');
        } catch (e) {
          /* cross-origin image: keep the default cream */
        }
      }
      if (img.complete && img.naturalWidth) apply();
      else img.addEventListener('load', apply, { once: true });
    }
    function init() {
      document.querySelectorAll('.rc-pbanner').forEach(sample);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-fbt"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function money(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' lei';
    }

    function init(root) {
      if (root.dataset.fbtReady) return;
      root.dataset.fbtReady = '1';
      var inputs = root.querySelectorAll('[data-fbt-item]');
      var totalEl = root.querySelector('[data-fbt-total]');
      var oldEl = root.querySelector('[data-fbt-old]');
      var saveEl = root.querySelector('[data-fbt-save]');
      var btn = root.querySelector('[data-fbt-add]');
      var btnLabel = root.querySelector('[data-fbt-btn-label]');
      var errorEl = root.querySelector('[data-fbt-error]');

      function update() {
        var total = 0, old = 0, count = 0;
        inputs.forEach(function (i) {
          if (!i.checked) return;
          total += parseInt(i.getAttribute('data-price'), 10) || 0;
          old += parseInt(i.getAttribute('data-compare'), 10) || 0;
          count++;
        });
        totalEl.textContent = money(total);
        oldEl.textContent = old > total ? money(old) : '';
        saveEl.textContent = old > total ? 'Economisești ' + money(old - total) : '';
        btnLabel.textContent = count > 1 ? 'Adaugă ' + count + ' produse în coș' : 'Adaugă în coș';
      }

      inputs.forEach(function (i) { i.addEventListener('change', update); });
      update();

      btn.addEventListener('click', function () {
        var items = [];
        inputs.forEach(function (i) {
          if (i.checked) items.push({ id: parseInt(i.getAttribute('data-variant'), 10), quantity: 1 });
        });
        if (!items.length) return;
        btn.setAttribute('aria-busy', 'true');
        errorEl.hidden = true;
        fetch(root.getAttribute('data-cart-add'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            window.location.href = root.getAttribute('data-cart-url');
          })
          .catch(function () {
            btn.removeAttribute('aria-busy');
            errorEl.hidden = false;
          });
      });
    }

    function run() {
      document.querySelectorAll('[data-rc-fbt]').forEach(init);
    }

    document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related"] && !Shopify.designMode) return;
  try {
    
  /* RoyalCare: "Completează rutina" - type tabs + carousel arrows. "Toate" mixes the types (one of each in turn). */
  if (!customElements.get('rc-related-tabs')) {
    customElements.define(
      'rc-related-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.limit = parseInt(this.dataset.limit, 10) || 15;
          this.items = Array.prototype.slice.call(this.querySelectorAll('.rc-related__item'));
          this.grid = this.querySelector('.rc-related__grid');
          this.carousel = this.querySelector('.rc-related__carousel');
          this.prev = this.querySelector('[data-rc-prev]');
          this.next = this.querySelector('[data-rc-next]');
          this.addEventListener('click', (event) => {
            var tab = event.target instanceof Element ? event.target.closest('[data-rc-tab]') : null;
            if (tab) this.select(tab);
          });
          var self = this;
          if (this.prev) this.prev.addEventListener('click', function () { self.grid.scrollBy({ left: -self.step(), behavior: 'smooth' }); });
          if (this.next) this.next.addEventListener('click', function () { self.grid.scrollBy({ left: self.step(), behavior: 'smooth' }); });
          this.grid.addEventListener('scroll', function () { self.updateArrows(); }, { passive: true });
          window.addEventListener('resize', function () { self.updateArrows(); });
          var items = this.items;
          this.querySelectorAll('[data-rc-tab]').forEach(function (tab) {
            var type = tab.getAttribute('data-rc-tab');
            var n = Math.min(self.limit, type ? items.filter(function (i) { return i.dataset.rcType === type; }).length : items.length);
            var c = tab.querySelector('[data-rc-count]');
            if (c) c.textContent = n;
          });
          this.show('');
        }

        step() {
          var card = this.items.find(function (i) { return !i.classList.contains('is-hidden'); });
          if (!card) return this.grid.clientWidth * 0.8;
          var gap = parseFloat(getComputedStyle(this.grid).columnGap) || 0;
          return card.getBoundingClientRect().width + gap;
        }

        updateArrows() {
          var max = this.grid.scrollWidth - this.grid.clientWidth - 2;
          if (this.carousel) this.carousel.classList.toggle('is-static', max <= 0);
          if (this.prev) this.prev.disabled = this.grid.scrollLeft <= 0;
          if (this.next) this.next.disabled = this.grid.scrollLeft >= max;
        }

        select(tab) {
          this.querySelectorAll('[data-rc-tab]').forEach(function (t) {
            var active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          this.show(tab.getAttribute('data-rc-tab'));
        }

        show(type) {
          var picked = [];
          if (type) {
            picked = this.items.filter(function (item) { return item.dataset.rcType === type; }).slice(0, this.limit);
          } else {
            var groups = {};
            var order = [];
            this.items.forEach(function (item) {
              var key = item.dataset.rcType || '';
              if (!groups[key]) {
                groups[key] = [];
                order.push(key);
              }
              groups[key].push(item);
            });
            var round = 0;
            while (picked.length < this.limit) {
              var added = false;
              for (var i = 0; i < order.length && picked.length < this.limit; i++) {
                var next = groups[order[i]][round];
                if (next) {
                  picked.push(next);
                  added = true;
                }
              }
              if (!added) break;
              round += 1;
            }
          }
          this.items.forEach(function (item) {
            item.classList.toggle('is-hidden', picked.indexOf(item) === -1);
          });
          var grid = this.grid;
          picked.forEach(function (item) { grid.appendChild(item); });
          grid.scrollLeft = 0;
          this.updateArrows();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-results"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rc-results-timeline')) {
    customElements.define(
      'rc-results-timeline',
      class extends HTMLElement {
        connectedCallback() {
          this.steps = Array.from(this.querySelectorAll('.rc-presults__step'));
          this.update = this.update.bind(this);
          this.style.setProperty('--rc-progress', 0);
          // the theme scrolls inside .page-wrapper, so listen to scroll on any element (capture)
          document.addEventListener('scroll', this.update, { passive: true, capture: true });
          window.addEventListener('resize', this.update);
          this.update();
        }

        disconnectedCallback() {
          document.removeEventListener('scroll', this.update, { capture: true });
          window.removeEventListener('resize', this.update);
        }

        update() {
          var line = window.innerHeight * 0.62;
          var rail = this.querySelector('.rc-presults__rail').getBoundingClientRect();
          var progress = rail.height > 0 ? (line - rail.top) / rail.height : 1;
          this.style.setProperty('--rc-progress', Math.max(0, Math.min(1, progress)).toFixed(3));
          this.steps.forEach(function (step) {
            var node = step.querySelector('.rc-presults__node').getBoundingClientRect();
            step.classList.toggle('is-reached', node.top + node.height / 2 <= line);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  /* RoyalCare: product reviews v2 - all reviews from Judge.me, client-side filters, sorting, pagination,
     photo/video lightbox, and a write-a-review dialog posting to Judge.me. */
  (function () {
    var PUBLIC_TOKEN = '0Ug1M_aYNEnpvIKuNs3YzWV3zIA';
    var BATCH = 50;

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function starsHtml(n, small) {
      var html = '<span class="rc-prev__stars' + (small ? ' rc-prev__stars--sm' : '') + '" aria-label="' + n + ' din 5 stele">';
      for (var i = 1; i <= 5; i++) html += '<i class="fa-solid fa-star' + (i > Math.round(n) ? ' is-off' : '') + '" aria-hidden="true"></i>';
      return html + '</span>';
    }

    function attr(el, names) {
      for (var i = 0; i < names.length; i++) {
        var v = el && el.getAttribute(names[i]);
        if (v) return v;
      }
      return '';
    }

    /* One Judge.me review element -> plain object */
    function parseReview(el) {
      var ratingEl = el.querySelector('.jdgm-rev__rating');
      var bodyEl = el.querySelector('.jdgm-rev__body');
      var body = '';
      if (bodyEl) {
        body = Array.prototype.map.call(bodyEl.querySelectorAll('p'), function (p) { return p.textContent.trim(); }).filter(Boolean).join('\n')
          || bodyEl.textContent.trim();
      }
      var media = [];
      el.querySelectorAll('.jdgm-rev__pics a, .jdgm-rev__pics img').forEach(function (node) {
        if (node.tagName === 'IMG' && node.closest('a')) return;
        var img = node.tagName === 'IMG' ? node : node.querySelector('img');
        var full = node.tagName === 'A' ? attr(node, ['href', 'data-mfp-src']) : '';
        var thumb = attr(img, ['data-src', 'src']);
        full = full || thumb;
        /* Judge.me's own thumbnail is only 160 px wide (blurry on the cards): ask its CDN for bigger sizes */
        if (full) media.push({ type: 'image', src: sized(full, 1600), thumb: sized(full, 360) });
      });
      el.querySelectorAll('.jdgm-rev__vids video, .jdgm-rev__vids iframe, .jdgm-rev__vids [data-src], .jdgm-rev__vids [data-video-url]').forEach(function (node) {
        var src = attr(node, ['data-video-url', 'data-src', 'src']);
        if (!src) {
          var source = node.querySelector && node.querySelector('source');
          src = attr(source, ['src', 'data-src']);
        }
        if (!src || media.some(function (m) { return m.src === src; })) return;
        var isFile = /\.(mp4|webm|mov|m3u8)(\?|$)/i.test(src) || node.tagName === 'VIDEO';
        media.push({ type: isFile ? 'video' : 'embed', src: src, thumb: attr(node, ['poster', 'data-poster', 'data-thumbnail']) });
      });
      var replyEl = el.querySelector('.jdgm-rev__reply-content, .jdgm-rev__reply');
      var reply = replyEl ? replyEl.textContent.replace(/\s+/g, ' ').trim() : '';
      return {
        id: el.getAttribute('data-review-id') || Math.random().toString(36),
        rating: parseInt(ratingEl && ratingEl.getAttribute('data-score'), 10) || 5,
        author: ((el.querySelector('.jdgm-rev__author') || {}).textContent || 'Client').trim() || 'Client',
        title: ((el.querySelector('.jdgm-rev__title') || {}).textContent || '').trim(),
        body: body,
        date: attr(el.querySelector('.jdgm-rev__timestamp'), ['datetime', 'data-content']),
        verified: el.getAttribute('data-verified-buyer') === 'true',
        reply: reply,
        media: media
      };
    }

    /* Judge.me image URL at a given width (its CDN resizes on the fly); other URLs unchanged */
    function sized(url, w) {
      if (!/judgeme\.com/.test(url)) return url;
      if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1' + w);
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }

    function mediaThumb(m) {
      if (m.type === 'image') return '<img src="' + esc(m.thumb || m.src) + '" alt="" loading="lazy">';
      if (m.type === 'video' && m.thumb) return '<img src="' + esc(m.thumb) + '" alt="" loading="lazy">';
      if (m.type === 'video') return '<video src="' + esc(m.src) + '#t=0.5" muted playsinline preload="metadata"></video>';
      return '<img src="' + esc(m.thumb || '') + '" alt="" loading="lazy">';
    }

    function cardHtml(r, index) {
      var html = '<article class="rc-prev__card">';
      /* up to 3 square thumbnails; the third shows "+N" when there are more */
      var pics = '';
      if (r.media.length) {
        var shown = r.media.slice(0, 3);
        pics = '<div class="rc-prev__pics">' + shown.map(function (m, mi) {
          var more = mi === shown.length - 1 && r.media.length > shown.length;
          return '<button type="button" class="rc-prev__pic" data-rc-open="' + index + '" data-rc-open-media="' + mi + '" aria-label="Vezi poza / video">'
            + mediaThumb(m)
            + (m.type !== 'image' && !more ? '<span class="rc-prev__play"><i class="fa-solid fa-circle-play" aria-hidden="true"></i></span>' : '')
            + (more ? '<span class="rc-prev__more-media">+' + (r.media.length - shown.length) + '</span>' : '')
            + '</button>';
        }).join('') + '</div>';
      }
      var long = r.body.length > 320;
      html += '<div class="rc-prev__card-body">' + starsHtml(r.rating, true)
        + (r.title ? '<p class="rc-prev__title">' + esc(r.title) + '</p>' : '')
        + '<p class="rc-prev__body' + (long ? ' is-clamped' : '') + '">' + esc(r.body).replace(/\n/g, '<br>') + '</p>'
        + (long ? '<button type="button" class="rc-prev__read" data-rc-read>Citește tot</button>' : '')
        + pics
        + (r.reply ? '<div class="rc-prev__reply"><strong>Răspuns RoyalCare</strong>' + esc(r.reply) + '</div>' : '')
        + '<footer class="rc-prev__card-foot"><span class="rc-prev__avatar">' + esc(r.author.charAt(0).toUpperCase()) + '</span>'
        + '<span class="rc-prev__who"><strong>' + esc(r.author) + '</strong>'
        + (r.verified ? '<span><i class="fa-solid fa-circle-check" aria-hidden="true"></i> Client verificat</span>' : '')
        + '</span></footer></div></article>';
      return html;
    }

    function init(section) {
      if (section.__rcInit) return;
      section.__rcInit = true;

      var shop = section.getAttribute('data-shop');
      var product = section.getAttribute('data-product');
      var total = parseInt(section.getAttribute('data-total'), 10) || 0;
      var perPageSetting = parseInt(section.getAttribute('data-per-page'), 10) || 9;
      var grid = section.querySelector('[data-rc-grid]');
      var toolbar = section.querySelector('[data-rc-toolbar]');
      var chipsBox = section.querySelector('[data-rc-chips]');
      var sortSel = section.querySelector('[data-rc-sort]');
      var pagesBox = section.querySelector('[data-rc-pages]');
      var noneMsg = section.querySelector('[data-rc-none]');
      var mediaBox = section.querySelector('[data-rc-media]');
      var mediaStrip = section.querySelector('[data-rc-media-strip]');
      var lightbox = section.querySelector('[data-rc-lightbox]');
      var stage = section.querySelector('[data-rc-lb-stage]');
      var caption = section.querySelector('[data-rc-lb-caption]');
      var lbPrev = section.querySelector('[data-rc-lb-prev]');
      var lbNext = section.querySelector('[data-rc-lb-next]');

      var all = [];
      var view = [];
      var state = { filter: 'all', sort: 'new', page: 1 };
      var lb = { list: [], index: 0 };

      function perPage() {
        return window.matchMedia('(max-width: 749px)').matches ? Math.min(perPageSetting, 6) : perPageSetting;
      }

      /* ---------- loading ---------- */
      function loadPage(page) {
        var url = 'https://judge.me/api/v1/widgets/product_review?shop_domain=' + encodeURIComponent(shop)
          + '&api_token=' + PUBLIC_TOKEN + '&external_id=' + encodeURIComponent(product)
          + '&per_page=' + BATCH + '&page=' + page
          /* changes every minute, so the browser never reuses an old list (new reviews show right away) */
          + '&_=' + Math.floor(Date.now() / 60000);
        return fetch(url, { cache: 'no-store' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (data) {
          if (!data || !data.widget) throw new Error('no data');
          var doc = new DOMParser().parseFromString(data.widget, 'text/html');
          var widget = doc.querySelector('.jdgm-rev-widg');
          if (widget) total = parseInt(widget.getAttribute('data-number-of-reviews'), 10) || total;
          return Array.prototype.map.call(doc.querySelectorAll('.jdgm-rev'), parseReview);
        });
      }

      function loadAll() {
        var page = 1;
        function next() {
          return loadPage(page).then(function (items) {
            all = all.concat(items);
            if (items.length === BATCH && all.length < total && page < 20) {
              page += 1;
              return next();
            }
          });
        }
        return next();
      }

      /* ---------- summary from the full list ---------- */
      function refreshSummary() {
        if (!all.length) return;
        var counts = [0, 0, 0, 0, 0, 0];
        var sum = 0;
        all.forEach(function (r) { counts[r.rating] += 1; sum += r.rating; });
        var avg = sum / all.length;
        var avgEl = section.querySelector('[data-rc-avg]');
        if (avgEl) avgEl.textContent = (Math.round(avg * 10) / 10).toFixed(1).replace('.', ',');
        var starsEl = section.querySelector('[data-rc-avg-stars]');
        if (starsEl) starsEl.outerHTML = starsHtml(avg).replace('class="rc-prev__stars"', 'class="rc-prev__stars" data-rc-avg-stars');
        var countEl = section.querySelector('[data-rc-count]');
        if (countEl) countEl.textContent = all.length === 1 ? '1 recenzie' : all.length + ' recenzii';
        section.querySelectorAll('[data-rc-bars] .rc-prev__bar-btn').forEach(function (btn) {
          var star = parseInt(btn.getAttribute('data-rc-filter'), 10);
          btn.querySelector('.rc-prev__bar span').style.width = (counts[star] / all.length * 100) + '%';
          btn.querySelector('.rc-prev__bar-count').textContent = counts[star];
        });

        /* every photo / video, newest reviews first */
        var media = [];
        all.forEach(function (r, ri) { r.media.forEach(function (m, mi) { media.push({ r: ri, m: mi, item: m }); }); });
        if (media.length) {
          mediaStrip.innerHTML = media.slice(0, 24).map(function (x) {
            return '<button type="button" class="rc-prev__thumb" data-rc-thumb="' + x.r + ':' + x.m + '" aria-label="Vezi poza / video">'
              + mediaThumb(x.item) + (x.item.type !== 'image' ? '<span class="rc-prev__play"><i class="fa-solid fa-play" aria-hidden="true"></i></span>' : '')
              + '</button>';
          }).join('');
          mediaBox.hidden = false;
          section.__allMedia = media;
        }

        /* chips */
        var withMedia = all.filter(function (r) { return r.media.length; }).length;
        var chips = [{ key: 'all', label: 'Toate', n: all.length }];
        if (withMedia) chips.push({ key: 'media', label: '<i class="fa-solid fa-camera" aria-hidden="true"></i> Cu poze / video', n: withMedia });
        for (var s = 5; s >= 1; s--) {
          if (counts[s]) chips.push({ key: String(s), label: s + ' <i class="fa-solid fa-star" aria-hidden="true"></i>', n: counts[s] });
        }
        chipsBox.innerHTML = chips.map(function (c) {
          return '<button type="button" class="rc-prev__chip" data-rc-filter="' + c.key + '">' + c.label + ' <small>' + c.n + '</small></button>';
        }).join('');
        toolbar.hidden = all.length < 2;
      }

      /* ---------- list ---------- */
      function computeView() {
        view = all.map(function (r, i) { return { r: r, i: i }; }).filter(function (x) {
          if (state.filter === 'all') return true;
          if (state.filter === 'media') return x.r.media.length > 0;
          return x.r.rating === parseInt(state.filter, 10);
        });
        view.sort(function (a, b) {
          if (state.sort === 'best' && b.r.rating !== a.r.rating) return b.r.rating - a.r.rating;
          if (state.sort === 'media' && !!b.r.media.length !== !!a.r.media.length) return b.r.media.length ? 1 : -1;
          return new Date(b.r.date) - new Date(a.r.date);
        });
      }

      function renderPages(pages) {
        if (pages <= 1) { pagesBox.hidden = true; pagesBox.innerHTML = ''; return; }
        var p = state.page;
        var nums = [];
        for (var i = 1; i <= pages; i++) {
          if (i === 1 || i === pages || Math.abs(i - p) <= 1) nums.push(i);
          else if (nums[nums.length - 1] !== '…') nums.push('…');
        }
        pagesBox.innerHTML = '<button type="button" class="rc-prev__page" data-rc-page="' + (p - 1) + '"' + (p === 1 ? ' disabled' : '') + ' aria-label="Pagina anterioară"><i class="fa-solid fa-chevron-left" aria-hidden="true"></i></button>'
          + nums.map(function (n) {
            return n === '…' ? '<span class="rc-prev__dots">…</span>'
              : '<button type="button" class="rc-prev__page' + (n === p ? ' is-current" aria-current="page' : '') + '" data-rc-page="' + n + '">' + n + '</button>';
          }).join('')
          + '<button type="button" class="rc-prev__page" data-rc-page="' + (p + 1) + '"' + (p === pages ? ' disabled' : '') + ' aria-label="Pagina următoare"><i class="fa-solid fa-chevron-right" aria-hidden="true"></i></button>';
        pagesBox.hidden = false;
      }

      function render() {
        var per = perPage();
        var pages = Math.max(1, Math.ceil(view.length / per));
        state.page = Math.min(state.page, pages);
        var slice = view.slice((state.page - 1) * per, state.page * per);
        grid.innerHTML = slice.map(function (x) { return cardHtml(x.r, x.i); }).join('');
        grid.setAttribute('data-count', Math.min(slice.length, 3));
        noneMsg.hidden = view.length > 0;
        renderPages(pages);
        /* chips: the current filter ("Toate" included); star bars: only a star filter */
        section.querySelectorAll('[data-rc-filter]').forEach(function (b) {
          var key = b.getAttribute('data-rc-filter');
          var isChip = b.classList.contains('rc-prev__chip');
          b.classList.toggle('is-active', key === state.filter && (isChip || key !== 'all'));
        });
      }

      function scrollToTop() {
        var top = (toolbar.hidden ? grid : toolbar).getBoundingClientRect().top + window.scrollY - 110;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }

      section.addEventListener('click', function (e) {
        var f = e.target.closest('[data-rc-filter]');
        if (f && all.length) {
          var key = f.getAttribute('data-rc-filter');
          state.filter = state.filter === key && key !== 'all' ? 'all' : key;
          state.page = 1;
          computeView();
          render();
          if (f.closest('[data-rc-bars]')) scrollToTop();
          return;
        }
        var pg = e.target.closest('[data-rc-page]');
        if (pg && !pg.disabled) {
          state.page = parseInt(pg.getAttribute('data-rc-page'), 10);
          render();
          scrollToTop();
          return;
        }
        var read = e.target.closest('[data-rc-read]');
        if (read) {
          var body = read.previousElementSibling;
          var open = body.classList.toggle('is-clamped');
          read.textContent = open ? 'Citește tot' : 'Mai puțin';
          return;
        }
        var openBtn = e.target.closest('[data-rc-open]');
        if (openBtn) {
          var r = all[parseInt(openBtn.getAttribute('data-rc-open'), 10)];
          openLightbox(r.media.map(function (m) { return { item: m, r: r }; }), parseInt(openBtn.getAttribute('data-rc-open-media'), 10) || 0);
          return;
        }
        var thumb = e.target.closest('[data-rc-thumb]');
        if (thumb && section.__allMedia) {
          var list = section.__allMedia.map(function (x) { return { item: x.item, r: all[x.r] }; });
          var key2 = thumb.getAttribute('data-rc-thumb');
          var idx = section.__allMedia.findIndex(function (x) { return x.r + ':' + x.m === key2; });
          openLightbox(list, Math.max(0, idx));
        }
      });

      sortSel.addEventListener('change', function () {
        state.sort = sortSel.value;
        state.page = 1;
        computeView();
        render();
      });

      /* ---------- lightbox ---------- */
      function showMedia() {
        var x = lb.list[lb.index];
        var m = x.item;
        if (m.type === 'image') stage.innerHTML = '<img src="' + esc(m.src) + '" alt="Poză de la ' + esc(x.r.author) + '">';
        else if (m.type === 'video') stage.innerHTML = '<video src="' + esc(m.src) + '" controls autoplay playsinline></video>';
        else stage.innerHTML = '<iframe src="' + esc(m.src) + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="Video recenzie"></iframe>';
        caption.textContent = x.r.author + ' · ' + '★'.repeat(x.r.rating) + (lb.list.length > 1 ? '  (' + (lb.index + 1) + '/' + lb.list.length + ')' : '');
        lbPrev.hidden = lbNext.hidden = lb.list.length < 2;
      }

      function openLightbox(list, index) {
        if (!list.length) return;
        lb.list = list;
        lb.index = index;
        showMedia();
        lightbox.showModal();
      }

      function step(d) {
        lb.index = (lb.index + d + lb.list.length) % lb.list.length;
        showMedia();
      }

      lbPrev.addEventListener('click', function () { step(-1); });
      lbNext.addEventListener('click', function () { step(1); });
      section.querySelector('[data-rc-lb-close]').addEventListener('click', function () { lightbox.close(); });
      lightbox.addEventListener('click', function (e) { if (e.target === lightbox) lightbox.close(); });
      lightbox.addEventListener('close', function () { stage.innerHTML = ''; });
      lightbox.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') step(-1);
        if (e.key === 'ArrowRight') step(1);
      });

      /* ---------- write dialog ---------- */
      var dialog = section.querySelector('[data-rc-dialog]');
      var form = section.querySelector('[data-rc-form]');
      var msg = section.querySelector('[data-rc-msg]');
      var rating = 0;
      var fileInput = section.querySelector('[data-rc-files]');
      var previews = section.querySelector('[data-rc-previews]');
      var files = [];
      var LIMITS = { image: { count: 5, mb: 10 }, video: { count: 1, mb: 100 } };

      function kind(f) { return /^video\//.test(f.type) ? 'video' : 'image'; }

      function renderPreviews() {
        previews.innerHTML = files.map(function (f, i) {
          var url = f.__url || (f.__url = URL.createObjectURL(f));
          return '<div class="rc-prev__preview">'
            + (kind(f) === 'video' ? '<video src="' + url + '#t=0.5" muted playsinline preload="metadata"></video><span class="rc-prev__preview-badge">Video</span>'
              : '<img src="' + url + '" alt="">')
            + '<button type="button" class="rc-prev__preview-remove" data-rc-remove="' + i + '" aria-label="Șterge"><i class="fa-solid fa-xmark" aria-hidden="true"></i></button></div>';
        }).join('');
      }

      fileInput.addEventListener('change', function () {
        var problems = [];
        Array.prototype.forEach.call(fileInput.files, function (f) {
          var k = kind(f);
          var have = files.filter(function (x) { return kind(x) === k; }).length;
          if (f.size > LIMITS[k].mb * 1024 * 1024) { problems.push(f.name + ' depășește ' + LIMITS[k].mb + ' MB'); return; }
          if (have >= LIMITS[k].count) { problems.push(k === 'video' ? 'poți adăuga un singur video' : 'poți adăuga cel mult 5 poze'); return; }
          files.push(f);
        });
        fileInput.value = '';
        renderPreviews();
        msg.className = 'rc-prev__form-msg' + (problems.length ? ' is-error' : '');
        msg.textContent = problems.length ? 'Atenție: ' + problems.filter(function (v, i, a) { return a.indexOf(v) === i; }).join(', ') + '.' : '';
      });

      previews.addEventListener('click', function (e) {
        var rm = e.target.closest('[data-rc-remove]');
        if (!rm) return;
        files.splice(parseInt(rm.getAttribute('data-rc-remove'), 10), 1);
        renderPreviews();
      });

      /* Judge.me media upload (same flow as its own widget): presigned data -> direct upload -> returned key */
      var presigned = {};
      function getPresigned(k) {
        if (presigned[k]) return Promise.resolve(presigned[k]);
        var url = 'https://api.judge.me/api/v1/' + (k === 'video' ? 'videos' : 'pictures') + '/presigned_data'
          + '?url=' + encodeURIComponent(shop) + '&shop_domain=' + encodeURIComponent(shop) + '&platform=shopify';
        return fetch(url).then(function (r) { if (!r.ok) throw new Error('presign'); return r.json(); })
          .then(function (data) { presigned[k] = data; return data; });
      }

      function uploadOne(f) {
        var k = kind(f);
        return getPresigned(k).then(function (data) {
          var clean = (f.name || 'fisier').replace(/[^a-zA-Z0-9._-]/g, '_').slice(-60);
          var fd = new FormData();
          fd.append('key', data.key_prefix + Date.now() + '_' + Math.random().toString(36).slice(2, 8) + '_' + clean);
          Object.keys(data.fields || {}).forEach(function (name) { fd.append(name, data.fields[name]); });
          fd.append('file', f);
          return fetch(data.url, { method: 'POST', body: fd }).then(function (r) {
            if (!r.ok) throw new Error('upload');
            return r.text();
          }).then(function (xml) {
            var m = xml.match(/<Key>([^<]+)<\/Key>/);
            if (!m) throw new Error('key');
            return { kind: k, key: m[1] };
          });
        });
      }

      section.querySelector('[data-rc-write]').addEventListener('click', function () {
        dialog.showModal();
        var first = form.querySelector('input[name="name"]');
        if (first) first.focus();
      });
      section.querySelector('[data-rc-close]').addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });

      form.querySelectorAll('[data-rate]').forEach(function (star) {
        star.addEventListener('click', function () {
          rating = parseInt(star.getAttribute('data-rate'), 10);
          form.querySelectorAll('[data-rate]').forEach(function (s) {
            var n = parseInt(s.getAttribute('data-rate'), 10);
            s.classList.toggle('is-on', n <= rating);
            s.setAttribute('aria-checked', String(n === rating));
          });
        });
      });

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var name = form.elements['name'].value.trim();
        var email = form.elements['email'].value.trim();
        var body = form.elements['body'].value.trim();
        msg.className = 'rc-prev__form-msg';
        if (!rating) { msg.textContent = 'Alege o notă de la 1 la 5 stele.'; msg.classList.add('is-error'); return; }
        if (!name || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email) || !body) {
          msg.textContent = 'Completează numele, un email valid și recenzia.';
          msg.classList.add('is-error');
          return;
        }
        var submit = form.querySelector('.rc-prev__submit');
        submit.disabled = true;
        submit.textContent = files.length ? 'Se încarcă pozele...' : 'Se trimite...';

        /* upload the photos / video one by one, then send the review with their keys */
        var keys = [];
        var chain = Promise.resolve();
        files.forEach(function (f, i) {
          chain = chain.then(function () {
            submit.textContent = 'Se încarcă ' + (i + 1) + ' din ' + files.length + '...';
            return uploadOne(f).then(function (res) { keys.push(res); });
          });
        });

        chain.then(function () {
          submit.textContent = 'Se trimite...';
          /* multipart form post (a JSON body is blocked by the browser's cross-site rules) */
          var fd = new FormData();
          var fields = { shop_domain: shop, url: shop, platform: 'shopify', id: product, name: name, email: email,
                         rating: String(rating), title: form.elements['title'].value.trim(), body: body };
          Object.keys(fields).forEach(function (k) { if (fields[k]) fd.append(k, fields[k]); });
          var pi = 0, vi = 0;
          keys.forEach(function (x) {
            if (x.kind === 'video') fd.append('video_keys[' + (vi++) + ']', x.key);
            else fd.append('picture_keys[' + (pi++) + ']', x.key);
          });
          return fetch('https://api.judge.me/api/v1/reviews', { method: 'POST', body: fd });
        })
          .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, data: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.data && res.data.message) || 'error');
            form.innerHTML = '<button type="button" class="rc-prev__close" aria-label="Închide" onclick="this.closest(\'dialog\').close()"><i class="fa-solid fa-xmark" aria-hidden="true"></i></button>'
              + '<p class="rc-prev__form-title">Mulțumim pentru recenzie!</p>'
              + '<p class="rc-prev__form-msg is-ok">Recenzia ta a fost trimisă. Îți mulțumim că ne ajuți să creștem!</p>';
            files = [];
            if (section.__rcReload) setTimeout(section.__rcReload, 4000);
          })
          .catch(function () {
            submit.disabled = false;
            submit.textContent = 'Trimite recenzia';
            msg.textContent = 'Nu am putut trimite recenzia. Te rugăm să încerci din nou.';
            msg.classList.add('is-error');
          });
      });

      /* ---------- start: load everything when the section comes near the screen ---------- */
      if (!total) return;
      var started = false;
      function go() {
        if (started) return;
        started = true;
        loadAll().then(function () {
          if (!all.length) return;
          refreshSummary();
          computeView();
          render();
        }).catch(function () { /* keep the server-rendered reviews */ });
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); go(); }
        }, { rootMargin: '800px 0px' });
        io.observe(section);
      } else {
        go();
      }
      /* fallback: load anyway a few seconds after the page has loaded */
      window.addEventListener('load', function () { setTimeout(go, 4000); });
      if (document.readyState === 'complete') setTimeout(go, 4000);
      section.__rcReload = function () { all = []; started = false; go(); };
    }

    function start() {
      document.querySelectorAll('.rc-prev').forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.rc-prodshow').forEach(function (section) {
      var revealEls = section.querySelectorAll('.rc-reveal');
      if (!('IntersectionObserver' in window) || revealEls.length === 0) {
        revealEls.forEach(function (el) { el.classList.add('is-in'); });
      } else {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-in');
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.1 }
        );
        revealEls.forEach(function (el) { observer.observe(el); });
      }

      /* ---- Category tabs ---- */
      var tabsWrap = section.querySelector('.rc-prodshow__tabs');
      var carousel = section.querySelector('.rc-prodshow__carousel');
      var items = Array.prototype.slice.call(section.querySelectorAll('.rc-prodshow__item[data-rc-cat]'));
      var limit = parseInt(section.getAttribute('data-limit'), 10) || 8;
      var refreshArrows = function () {};
      function showCat(cat) {
        var shown = 0;
        items.forEach(function (item) {
          var ok = item.getAttribute('data-rc-cat') === (cat || '__all') && shown < limit;
          if (ok) shown += 1;
          item.classList.toggle('is-hidden', !ok);
        });
        var g = section.querySelector('.rc-prodshow__grid');
        if (g) g.scrollLeft = 0;
        refreshArrows();
      }
      if (tabsWrap && items.length) {
        var tabs = Array.prototype.slice.call(tabsWrap.querySelectorAll('[data-rc-tab]'));
        var visibleTabs = 0;
        tabs.forEach(function (tab) {
          var cat = tab.getAttribute('data-rc-tab');
          var n = Math.min(limit, items.filter(function (i) { return i.getAttribute('data-rc-cat') === (cat || '__all'); }).length);
          var c = tab.querySelector('[data-rc-count]');
          if (c) c.textContent = n;
          if (cat && n === 0) tab.hidden = true; else if (cat) visibleTabs += 1;
          tab.addEventListener('click', function () {
            tabs.forEach(function (t) {
              t.classList.toggle('is-active', t === tab);
              t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
            });
            showCat(cat);
          });
        });
        if (visibleTabs > 1) tabsWrap.hidden = false;
        showCat('');
      }

      /* ---- Carousel arrows ---- */
      var grid = section.querySelector('.rc-prodshow__grid');
      var prevBtn = section.querySelector('.rc-prodshow__arrow--prev');
      var nextBtn = section.querySelector('.rc-prodshow__arrow--next');
      if (!grid || !prevBtn || !nextBtn) return;

      function scrollStep() {
        var card = grid.querySelector('.rc-prodshow__item');
        if (!card) return grid.clientWidth * 0.8;
        var style = getComputedStyle(grid);
        var gap = parseFloat(style.columnGap || style.gap || 0);
        return card.getBoundingClientRect().width + gap;
      }

      function updateArrows() {
        var maxScroll = grid.scrollWidth - grid.clientWidth - 2;
        prevBtn.disabled = grid.scrollLeft <= 0;
        nextBtn.disabled = grid.scrollLeft >= maxScroll;
      }

      prevBtn.addEventListener('click', function () {
        grid.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function () {
        grid.scrollBy({ left: scrollStep(), behavior: 'smooth' });
      });
      refreshArrows = function () {
        if (carousel) carousel.classList.toggle('is-static', grid.scrollWidth - grid.clientWidth <= 2);
        updateArrows();
      };
      grid.addEventListener('scroll', updateArrows);
      window.addEventListener('resize', refreshArrows);
      refreshArrows();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-story"] && !Shopify.designMode) return;
  try {
    
  /* RoyalCare: before/after comparison - drag anywhere on the image, or use the arrow keys.
     Mouse uses pointer events; touch uses touch events so a horizontal drag can block the native
     scroll (the product gallery is a horizontal scroller - on iPhone it fought the drag and stuttered).
     Position updates are batched per animation frame. */
  if (!customElements.get('rc-before-after')) {
    customElements.define(
      'rc-before-after',
      class extends HTMLElement {
        connectedCallback() {
          this.range = this.querySelector('.rc-ba__range');
          this.pending = null;
          this.frame = 0;
          this.onDown = this.onDown.bind(this);
          this.onMove = this.onMove.bind(this);
          this.onUp = this.onUp.bind(this);
          this.onTouchStart = this.onTouchStart.bind(this);
          this.onTouchMove = this.onTouchMove.bind(this);
          this.onTouchEnd = this.onTouchEnd.bind(this);
          this.addEventListener('pointerdown', this.onDown);
          /* Inside the product gallery the slideshow drags on mousedown - keep the drag for the comparison */
          this.addEventListener('mousedown', function (event) { event.stopPropagation(); });
          this.addEventListener('touchstart', this.onTouchStart, { passive: true });
          this.addEventListener('touchmove', this.onTouchMove, { passive: false });
          this.addEventListener('touchend', this.onTouchEnd);
          this.addEventListener('touchcancel', this.onTouchEnd);
          this.range.addEventListener('input', () => this.setPos(Number(this.range.value)));
        }

        setPos(pos) {
          this.pending = Math.max(0, Math.min(100, pos));
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.style.setProperty('--rc-ba-pos', this.pending + '%');
            this.range.value = String(Math.round(this.pending));
            this.classList.add('is-touched');
          });
        }

        posFromPoint(clientX) {
          if (!this.rect) this.rect = this.getBoundingClientRect();
          return ((clientX - this.rect.left) / this.rect.width) * 100;
        }

        /* ---- mouse / pen ---- */
        onDown(event) {
          if (event.pointerType === 'touch') return;
          if (event.button !== undefined && event.button !== 0) return;
          this.rect = this.getBoundingClientRect();
          this.dragging = true;
          this.classList.add('is-dragging');
          this.setPos(this.posFromPoint(event.clientX));
          window.addEventListener('pointermove', this.onMove);
          window.addEventListener('pointerup', this.onUp);
          window.addEventListener('pointercancel', this.onUp);
        }

        onMove(event) {
          if (this.dragging) this.setPos(this.posFromPoint(event.clientX));
        }

        onUp() {
          this.dragging = false;
          this.classList.remove('is-dragging');
          window.removeEventListener('pointermove', this.onMove);
          window.removeEventListener('pointerup', this.onUp);
          window.removeEventListener('pointercancel', this.onUp);
        }

        /* ---- touch: decide on the first few pixels - horizontal = drag the divider, vertical = scroll the page ---- */
        onTouchStart(event) {
          if (event.touches.length !== 1) return;
          var t = event.touches[0];
          this.rect = this.getBoundingClientRect();
          this.tx = t.clientX;
          this.ty = t.clientY;
          this.mode = null;
        }

        onTouchMove(event) {
          if (event.touches.length !== 1 || this.mode === 'v') return;
          var t = event.touches[0];
          if (!this.mode) {
            var dx = Math.abs(t.clientX - this.tx);
            var dy = Math.abs(t.clientY - this.ty);
            if (dx < 4 && dy < 4) return;
            this.mode = dx >= dy ? 'h' : 'v';
            if (this.mode === 'v') return;
            this.classList.add('is-dragging');
          }
          event.preventDefault();
          event.stopPropagation();
          this.setPos(this.posFromPoint(t.clientX));
        }

        onTouchEnd(event) {
          /* A short tap (no drag) moves the divider to the tapped spot */
          if (!this.mode && event.type === 'touchend' && event.changedTouches.length) {
            this.setPos(this.posFromPoint(event.changedTouches[0].clientX));
          }
          this.mode = null;
          this.classList.remove('is-dragging');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-article"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.rc-post__copy');
    if (!button || !navigator.clipboard) return;
    navigator.clipboard.writeText(button.getAttribute('data-url')).then(function () {
      button.classList.add('is-copied');
      button.innerHTML = '<i class="fa-solid fa-check" aria-hidden="true"></i>';
      setTimeout(function () {
        button.classList.remove('is-copied');
        button.innerHTML = '<i class="fa-solid fa-link" aria-hidden="true"></i>';
      }, 2000);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-blog"] && !Shopify.designMode) return;
  try {
    
  /* RoyalCare: blog / collections list header description - 2 lines + "Vezi mai mult" when it is longer */
  (function () {
    function initHeroDesc(desc) {
      if (desc.dataset.rcMore) return;
      desc.dataset.rcMore = '1';
      if (desc.scrollHeight <= desc.clientHeight + 2) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rc-desc-more';
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = '<span>Vezi mai mult</span><i class="fa-solid fa-chevron-down" aria-hidden="true"></i>';
      btn.addEventListener('click', function () {
        var open = desc.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.querySelector('span').textContent = open ? 'Vezi mai puțin' : 'Vezi mai mult';
      });
      desc.insertAdjacentElement('afterend', btn);
    }
    function initAll() { document.querySelectorAll('.rc-bloghero__desc').forEach(initHeroDesc); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["return-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var revealEls = document.querySelectorAll('.rc-returnform .rc-reveal');
    if (!('IntersectionObserver' in window) || revealEls.length === 0) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.2 }
      );
      revealEls.forEach(function (el) { observer.observe(el); });
    }

    var form = document.querySelector('.rc-returnform__form');
    if (!form) return;
    form.addEventListener('submit', function () {
      var order = form.querySelector('[data-return-order]');
      var iban = form.querySelector('[data-return-iban]');
      var reason = form.querySelector('[data-return-reason]');
      var body = form.querySelector('[data-return-body]');
      var lines = ['Cerere de retragere / retur'];
      if (order && order.value) lines.push('Număr comandă: ' + order.value);
      if (iban && iban.value) lines.push('IBAN pentru rambursare: ' + iban.value);
      if (reason && reason.value) lines.push('Motivul retragerii: ' + reason.value);
      if (body) body.value = lines.join('\n');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["return-info"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var revealEls = document.querySelectorAll('.rc-returninfo .rc-reveal');
    if (!('IntersectionObserver' in window) || revealEls.length === 0) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-info"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var revealEls = document.querySelectorAll('.rc-shipinfo .rc-reveal');
    if (!('IntersectionObserver' in window) || revealEls.length === 0) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var revealEls = document.querySelectorAll('.rc-storybanner .rc-reveal');
    if (!('IntersectionObserver' in window) || revealEls.length === 0) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var revealEls = document.querySelectorAll('.rc-testimonials .rc-reveal');
    if (!('IntersectionObserver' in window) || revealEls.length === 0) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    revealEls.forEach(function (el) { observer.observe(el); });

    (function () {
      var section = document.getElementById('recenzii');
      if (!section) return;
      var shopDomain = section.getAttribute('data-judgeme-shop');
      var productId = section.getAttribute('data-judgeme-product');
      var productUrl = section.getAttribute('data-judgeme-url') || '';
      if (!shopDomain || !productId) return;
      var grid = section.querySelector('.rc-testimonials__grid');
      if (!grid) return;

      var url = 'https://judge.me/api/v1/widgets/product_review'
        + '?shop_domain=' + encodeURIComponent(shopDomain)
        + '&api_token=0Ug1M_aYNEnpvIKuNs3YzWV3zIA'
        + '&external_id=' + encodeURIComponent(productId)
        + '&per_page=10';

      function truncate(text, max) {
        text = text.trim();
        if (text.length <= max) return text;
        var cut = text.slice(0, max);
        var lastSpace = cut.lastIndexOf(' ');
        if (lastSpace > 40) cut = cut.slice(0, lastSpace);
        return cut + '…';
      }
      function escapeHtml(s) {
        return String(s).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }
      function showFallback() {
        var tpl = document.getElementById('rc-testimonials-fallback');
        if (!tpl) return;
        grid.innerHTML = tpl.innerHTML;
        grid.classList.remove('rc-testimonials__grid--judgeme');
      }

      fetch(url)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || !data.widget) return showFallback();
          var doc = new DOMParser().parseFromString(data.widget, 'text/html');
          var root = doc.querySelector('.jdgm-rev-widg');
          var totalCount = root ? parseInt(root.getAttribute('data-number-of-reviews') || '0', 10) : 0;
          var items = Array.prototype.slice.call(doc.querySelectorAll('.jdgm-rev'));
          if (!items.length) return showFallback();

          var html = items.map(function (item) {
            var ratingEl = item.querySelector('.jdgm-rev__rating');
            var rating = ratingEl ? parseInt(ratingEl.getAttribute('data-score') || '5', 10) : 5;
            var authorEl = item.querySelector('.jdgm-rev__author');
            var author = (authorEl ? authorEl.textContent : 'Client').trim() || 'Client';
            var bodyEl = item.querySelector('.jdgm-rev__body');
            var body = bodyEl ? truncate(bodyEl.textContent, 200) : '';
            var initial = author.charAt(0).toUpperCase() || 'C';

            var starsHtml = '';
            for (var i = 1; i <= 5; i++) {
              starsHtml += '<i class="fa-solid fa-star" style="color: ' + (i <= rating ? '#C3A15A' : '#E7DCCB') + ';" aria-hidden="true"></i>';
            }

            return (
              '<div class="rc-testimonial">'
              + '<div class="rc-testimonial__head">'
              + '<span class="rc-testimonial__avatar-img rc-testimonial__avatar-initial">' + escapeHtml(initial) + '</span>'
              + '<div>'
              + '<p class="rc-testimonial__name">' + escapeHtml(author) + '</p>'
              + '<div class="rc-testimonial__stars">' + starsHtml + '</div>'
              + '</div>'
              + '</div>'
              + '<p class="rc-testimonial__quote">„' + escapeHtml(body) + '"</p>'
              + '</div>'
            );
          }).join('');

          if (totalCount > items.length) {
            html += (
              '<a href="' + productUrl + '#recenzii" class="rc-testimonial rc-testimonial--more">'
              + '<span>Vezi mai multe recenzii<i class="fa-solid fa-chevron-right" aria-hidden="true"></i></span>'
              + '</a>'
            );
          }

          grid.innerHTML = html;
          grid.classList.add('rc-testimonials__grid--judgeme');
          section.classList.add('rc-testimonials--carousel');
          initArrows();
        })
        .catch(function () { showFallback(); });

      function initArrows() {
        var prev = section.querySelector('[data-testi-prev]');
        var next = section.querySelector('[data-testi-next]');
        if (!prev || !next) return;
        function step() {
          var c = grid.querySelector('.rc-testimonial, .rc-testimonial-skel');
          return c ? c.getBoundingClientRect().width + 24 : 300;
        }
        function update() {
          prev.disabled = grid.scrollLeft <= 2;
          next.disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2;
        }
        prev.addEventListener('click', function () { grid.scrollBy({ left: -step(), behavior: 'smooth' }); setTimeout(update, 400); });
        next.addEventListener('click', function () { grid.scrollBy({ left: step(), behavior: 'smooth' }); setTimeout(update, 400); });
        grid.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      }
    })();
  });

  } catch(e) { console.error(e); }
})();
})();
